// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import HelloSign from 'hellosign-embedded';

// Create the HelloSign Embedded instance.
// Only do this once!

let STAGING_QANDID_CLIENT_ID = '75157d2ef3a1d8729b898ff72ccc256f'
let QANDID_CLIENT_ID = '37bff4c8e845f2eda5ec3d76d0fb9898'
let TRADELINE_STORE_CLIENT_ID = 'd19ee84320e885a741b9fc8800579b1f'

let elem_hellosign_client_id = document.getElementById('hellosign_client_id')
let elem_hellosign_domain = document.getElementById('hellosign_domain')

let DOMAIN_LOCALHOST = 'localhost'
let DOMAIN_QANDID = 'qandid.com'
let DOMAIN_TRADELINE_STORE = 'tradeline.store'
let DOMAIN_STAGING_QANDID = 'staging.qandid.com'

let user = undefined
let local = new RegExp(DOMAIN_LOCALHOST);
let staging = new RegExp(DOMAIN_STAGING_QANDID);
let live = new RegExp(DOMAIN_QANDID);
let tradeline = new RegExp(DOMAIN_TRADELINE_STORE);


if (local.test(window.location.href) || staging.test(window.location.href)) {
    user = STAGING_QANDID_CLIENT_ID
} else if (live.test(window.location.href)) {
    user = QANDID_CLIENT_ID
} else if (tradeline.test(window.location.href)) {
    user = TRADELINE_STORE_CLIENT_ID
} else if (elem_hellosign_client_id && elem_hellosign_domain) {
    let client_id = elem_hellosign_client_id.value;
    let custom_domain = elem_hellosign_domain.value;
    let reg_exp_custom_domain = new RegExp(custom_domain);

    if (reg_exp_custom_domain.test(window.location.href)){
        user = client_id
    } else {
        user = ''
        console.log('Hellosign client id is not defined')
    }
}

window.client = new HelloSign({
    clientId: user
});